module.exports = __webpack_public_path__ + "img/LamdeiniLearning-177.25f2e2c9.jpg";